module.exports = __webpack_public_path__ + "assets/images/no-image/payspace-image.ed5576daf6bf645f3c6977a3bbae10af.webp";